import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Plus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconEmail2Plus"><Path d="M11.25 19.25H5.75C4.09315 19.25 2.75 17.9069 2.75 16.25V7.75C2.75 6.09315 4.09314 4.75 5.75 4.75H18.5535C20.0427 4.75 21.2499 5.95722 21.2499 7.44639C21.2499 7.78583 21.0587 8.09632 20.7556 8.24906L13.3498 11.9805C12.5007 12.4084 11.4991 12.4084 10.65 11.9805L3 8.12597" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M15.75 17H22.25M19 13.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconEmail2Plus;
